<template>

    <div class="content-wrap page-einkehren">

        <header class="hero--index">
            <h1 class="hero-heading">
                <small>Braukunst aus Oberfranken</small>
                Zissel
            </h1>
            <router-link to="biere" class="btn"><span>Erkunde Zissel</span></router-link>
        </header>

        <section class="section--interlude">

            <div class="container">

                <div class="row">

                    <div class="col sm-8">

                        <h2>Kultige Atmosphäre</h2>

                        <p>in einer typischen Gasthausbrauerei
                            und fränkische Küche: <b>Zissel verbindet.</b>
                        </p>
                        <p>
                            Nach einer sportlichen Fahrradtour durch das Frankenland, einer Wanderung
                            oder wann immer Sie mögen:
                            Kehren Sie bei uns ein – in unseren Biergarten,
                            in den kühlen Braukeller oder in unsere neue Erlebniskneipe. Hier fühlt man sich wohl!
                        </p>

                    </div>

                </div>


            </div>

        </section>

        <section class="section--light">

            <div class="slider">

                <div class="slider-item">
                    <div class="slider-image">
                        <img src="assets/img/einkehren-slider-1.jpg" alt="Anwesen">
                    </div>

                    <div class="slider-text">

                        <h2>Unsere Privatbrauerei
                            <small>
                                am Rande von Kulmbach besteht seit 1898.
                            </small>
                        </h2>


                        <p>Zum Anwesen gehören Brauerei, Gaststätte mit Biergarten,
                            Brennerei und ein Gästehaus.</p>

                    </div>
                </div>


                <div class="slider-item">
                    <div class="slider-image">
                        <img src="assets/img/einkehren-slider-2.jpg" alt="Brauen">
                    </div>

                    <div class="slider-text">

                        <h2>Unsere Qualitätsbiere
                            <small>
                                werden mit Wasser aus eigenem
                                Tiefbrunnen nach dem Bayerischen Reinheitsgebot gebraut.
                            </small>
                        </h2>

                        <p>Probieren Sie das erfrischend herbe Helle, das untergärige Dunkle,
                            unser Rauchbier oder unser Ungespundetes.</p>
                    </div>
                </div>


                <div class="slider-item">
                    <div class="slider-image">
                        <img src="assets/img/einkehren-slider-3.jpg" alt="Gerichte">
                    </div>

                    <div class="slider-text">

                        <h2>Und weil zu fränkischem Bier
                            <small>
                                nun mal nichts so
                                gut passt wie die echte fränkische Küche,
                                servieren wir regional typische und köstliche Gerichte.
                            </small>
                        </h2>


                        <p>Auf Ihr Wohl!</p>

                    </div>

                </div>


            </div>
        </section>



        <app-footer></app-footer>


    </div>


</template>

<script>
import slider from 'owl.carousel'
import { mapGetters } from 'vuex'

import store from '../store'

import setParallax from '../lib/setParallax'
import scrollOver from '../lib/getScrollOverElement'
import appFooter from './partials/footer.vue'

export default {

    components: { appFooter },

    computed: mapGetters([ 'ageConfirmed' ]),

    data() {
        return {
            underAge: false,
        }
    },



    created() {

        this.$nextTick(() => {
            createSlider()
        })
        //setTimeout(() => this.showPopup = true, 4000)

    },

    mounted() {

        this.$nextTick(() => {

            setParallax({
                el: '[class^="hero"]',
                attr: 'background-position-y',
                speed: 10
            })

        })

    },

    methods: {



    }


}




function createSlider() {

    $('.slider').owlCarousel({
        items: 1,
    	nav: true,
    	lazy: false,
    	dots: false,
        autoplay: true,
        loop: true,
        animateOut: 'owl-animated-out',
        animateIn: 'owl-animated-in',
        navText: ['‹', '›']

    })

}
</script>



// WEBPACK FOOTER //
// einkehren.vue?25ca10c4